import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SEO from '../SEO';
import './LegalLayout.css';

export default function LegalLayout({ children, title, description }) {
  return (
    <>
      <SEO
        title={title}
        description={description}
      />
      <Header />
      <main className="legalLayout">
        <div className="legalLayout__container">
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
}


